<template>
  <el-dialog
      v-model="dialogVisible"
      width="250"
      :before-close="handleClose"
  >
    <div class="pt-2 text-xl">
      {{ctx.locale == 'en' ? customPriceType?.enName: customPriceType?.arName}}
    </div>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="dialogVisible = false">{{t('close')}}</el-button>
      </div>
    </template>
  </el-dialog>
  <button
      v-if="orderItem.customPriceInfo.customPriceTypeID"
      class="bg-blue-200 text-black hover:text-white font-bold py-1 px-2 rounded"
      type="button"
      @click="load"
  >
    <font-awesome-icon  class="text-blue-500 cursor-pointer outline-none" icon="dollar-sign"
    />
  </button>
</template>

<script setup lang="ts">
import {nextTick, onMounted, ref} from 'vue'
import {useHTTP} from "@/plugins/http";
import {ElMessage, ElLoading} from "element-plus";
import ItemSerial from "@/models/inventory/ItemSerial";
import {useI18n} from "vue-i18n";
import CustomPriceType from "@/models/inventory/CustomPrice";
import {useContext} from "@/plugins/context";

const props = defineProps(['orderItem'])

const http = useHTTP();
const ctx = useContext();

const messages = {
  en: {
    pleaseWait: 'Please wait...',
    close: 'Close',
  },
  ar: {
    pleaseWait: 'يرجى الانتظار...',
    close: 'اغلاق'
  }
}
const { t } = useI18n({ messages, useScope: 'global' })

const dialogVisible = ref(false)
const isLoading = ref(false)
const customPriceType = ref<CustomPriceType>()

onMounted(() => {
})

const handleClose = (done: () => void) => {
  if (!isLoading.value) {
    done();
  }
}

async function load() {
  dialogVisible.value = true
  await nextTick()
  isLoading.value = true;
  const loading = ElLoading.service({
    lock: true,
    target: document.querySelector(".el-dialog"),
    text: t('pleaseWait'),
  })

  try {
    const resp = await http.get<CustomPriceType>(`${CustomPriceType.ENDPOINT}/${props.orderItem.customPriceInfo.customPriceTypeID}`)
    customPriceType.value = CustomPriceType.from(resp);
  } catch (error) {
      ElMessage({
        message: error.body,
        type: 'error'
      })
  }
  loading.close()
  isLoading.value = false;
}
</script>

<style scoped>

</style>
